<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" closeable :close-on-click-overlay="false" close-icon="clear"
               @closed="onClosed">
      <div class="flex column main">
        <div class="flex1 flex column overflow-hidden pt15 pb30 pl15 pr15">
          <h3 class="fs18 tac color_333 fw500">选择院区</h3>
          <section
            class="flex mt15 flex-center flex-center-2 fs14 color_333"
            v-for="(data,index) in allList" :key="index"
            @click="selectThis(data)">
            <img :src="icon" alt="" class="mr30"> {{ data.name }}
          </section>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";
import NoData from "@/plugins/no-data";
import {isEmpty} from "@/lib/util";
import {dhry_jc_status, dhry_jy_status, handlerDhryAddressList} from "@/page/dhry/config";

export default {
  name: "confirm",
  filters: {},
  components: {NoData, VTabs},
  data() {
    return {
      currTab: '待完成',
      tabs: [{label: '待完成'}, {label: '全部'}],
      title: "",
      active: 0,
      message: "",
      icon: require('@/assets/ncp/icon-医院@3x.png'),
      allList: [],
      currHos: {},
      confirmBtnText: "我知道了",
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    selectThis(data) {
      this.type = 'confirm';
      this.currHos = data;
      this.close()
    },
    onClosed() {
      this.$emit('closed', this.type, this.currHos);
    },
    onClick(type) {
      this.type = type;
      this.close()
    },
    onChange(data) {
      // Log('data111111111111', data);
      if (isEmpty(data)) return;
      this.currTab = data.label;
    }
  },
}
</script>

<style scoped lang="scss">
.main {
  max-height: 70vh;
}

section {
  border: 1px solid #CCCCCC;
  height: 50px;
  border-radius: 5px;
}

img {
  width: 32px;
  height: 32px;
}

</style>



// WEBPACK FOOTER //
// src/plugins/dialog/dh-select-hos.vue